import { render, staticRenderFns } from "./TermsAndConditionsModal.vue?vue&type=template&id=8921ed0e&"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports